<template>
  <div class="media-list-Skeleton">
    <div class="d-md-block d-none">
      <div class="row mt-3">
        <div class="col-md-6 p-1">
          <b-skeleton height="400px"></b-skeleton>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div v-for="i in 4" :key="i" class="col-md-6 px-1 py-1">
              <b-skeleton height="195px"></b-skeleton>
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="row">
            <div v-for="i in 6" :key="i" class="col-md-2 p-1">
              <b-skeleton height="200px"></b-skeleton>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-md-none d-block px-0 mt-3">
      <b-skeleton-img height="250px"></b-skeleton-img>
    </div>
  </div>
</template>

<script>
export default {
  name: "MediaListSkeleton",
};
</script>

<style>
.media-list-Skeleton .b-skeleton {
  border-radius: 10px;
}
</style>
